import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../components/global/Button';
import { getFormikTouchedErrors } from '../../../../util/formik';
import VisibilityTogglePasswordField from '../../../../components/global/VisibilityTogglePasswordField';
import Label from '../../../../components/global/Label';

const propTypes = {
  values: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,
  loading: PropTypes.bool,
  className: PropTypes.string,
};

const RegisterViewPasswordCreateForm = ({
  values,
  handleSubmit,
  handleChange,
  handleBlur,
  loading,
  errors,
  touched,
  className,
}) => {
  const classes = classNames({
    'view-register-form': true,
    [className]: !!className,
  });
  const errorList = Object.values(
    getFormikTouchedErrors(errors, touched) ?? {},
  );

  return (
    <form className={classes} onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-12">
          <Label id="password">Password</Label>
          <VisibilityTogglePasswordField
            id="password"
            name="password"
            label="Password"
            labelSrOnly
            placeholder="Password"
            required
            type="password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
        </div>
        <div className="col-12">
          <Label id="password_confirm">Confirm your password</Label>
          <VisibilityTogglePasswordField
            id="password_confirm"
            name="password_confirm"
            label="Confirm your password"
            labelSrOnly
            placeholder="Password Confirm"
            required
            type="password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password_confirm}
          />
        </div>
      </div>

      {errorList?.length > 0 && (
        <ul className="mb-2 text-danger">
          {errorList.map(error => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      )}
      <div className="text-center mt-2">
        <Button type="submit" disabled={loading} loading={loading}>
          {loading ? 'Processing...' : 'Continue'}
        </Button>
      </div>
    </form>
  );
};

RegisterViewPasswordCreateForm.propTypes = propTypes;
export default RegisterViewPasswordCreateForm;
